import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/Home.js';
import AdminPage from './pages/Admin.js';
import Donations from './pages/Donations.js';
function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/donate" element={<Donations />} />
      </Routes>
    </Router>
  );
}

export default App;